export default __webpack_public_path__ + "static/text-hero-search-0b9f1160f9f431ef3854cb81345e3094.png";